(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskListAddEdit',
	};

	var form_id = 'tasklistaddedit-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var task_list_id = $('#' + form_id + 'id').val();

		// make sure the classification field and the description field are empty
		if (!task_list_id) {
			$('#' + form_id + 'entity_type').val('');
			$('#' + form_id + 'description').val('');
		}

		Adzuki.TaskManager.initTaskListForm(form_id);
	};
}(jQuery, window.Adzuki || {}));
